export default __webpack_public_path__ + "static/media/KK_P_Left_Top_aCrop.f0c17c37.svg";